import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_multi_session_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  supplier_guid: fromDatatype.GuidDataFieldInterface;
  purchaser_guid: fromDatatype.GuidDataFieldInterface;
  location_guids: fromDatatype.TextDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  execution_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_generic_doc_multi_session_RowClass
  implements bl_fi_generic_doc_multi_session_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  supplier_guid: fromDatatype.GuidDataFieldInterface;
  purchaser_guid: fromDatatype.GuidDataFieldInterface;
  location_guids: fromDatatype.TextDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  execution_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
